import { Navigate, Outlet } from 'react-router-dom';

import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { NBA_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { glossary } from '@sorare/core/src/lib/glossary';

const Layout = () => {
  const {
    flags: { useNbaPostseasonRevamp = false },
  } = useFeatureFlags();

  if (!useNbaPostseasonRevamp) {
    return <Navigate to={NBA_PLAY} replace />;
  }

  return (
    <>
      <PageHeader text={glossary.play} />
      <Outlet />
    </>
  );
};

export default Layout;
